import { gql } from '@apollo/client';

export const ADD_TO_CART_SUBMIT = gql`
  mutation AddToCart($input: [CartInput!]!) {
    addToCart(input: $input) {
      success
      message
      cartItems {
        id
        cartItemId
        campaignInventories {
          billboardId
          billboardName
          billboardType
          billboardThumbnailUrl
          billboardCountry
          billboardCurrencyCode
          billboardPeriodSubTotalPrice
        }
        overAlltotalPrice
      }
    }
  }
`;

export const DELETE_CART_SUBMIT = gql`
  mutation DeleteCartItem($accessToken: String!, $deleteItemId: String!, $itemType: String!) {
    deleteCartItem(accessToken: $accessToken, deleteItemId: $deleteItemId, itemType: $itemType) {
      success
      message
    }
  }
`;

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($accessToken: String!, $dealId: String!) {
    createPaymentIntent(accessToken: $accessToken, dealId: $dealId) {
      clientSecret
      code
      message
    }
  }
`;
